import i18n from '@/i18n';
import { TranslateResult } from 'vue-i18n';

export type ToastVariant = 'success' | 'danger' | 'info' | 'warning';
type Message = string | number | string[];

interface ToastInstance {
  notification: {
    open: (options: {
      message: string;
      rootClass?: string;
      position?: string;
      variant?: ToastVariant;
    }) => void;
  };
}

let toastInstance: ToastInstance | null = null;

export function setToast(instance: ToastInstance) {
  toastInstance = instance;
}

function getTranslatedMessage(
  message: Message | TranslateResult,
  isKey = true,
): string {
  if (typeof message !== 'string' || !isKey) {
    return String(message);
  }
  // @ts-ignore – false positive: TypeScript thinks this is infinitely recursive, but the call is safe
  return i18n.global.t(message);
}

export function showToast(message: Message, variant: ToastVariant = 'info') {
  if (!toastInstance) return;

  const tMsg = getTranslatedMessage(message, true);
  toastInstance.notification.open({
    message: tMsg,
    rootClass: 'toast toast-notification',
    position: 'bottom',
    variant,
  });
}

export function showSuccess(message: Message) {
  showToast(message, 'success');
}

export function showError(message: Message) {
  showToast(message, 'danger');
}

export function showInfo(message: Message) {
  showToast(message, 'info');
}

export function showWarning(message: Message) {
  showToast(message, 'warning');
}
